import { useEffect, useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { SvgIcon } from "../../common/SvgIcon";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  CustomNavAnchorSmall,
} from "./styles";
import { Link } from "react-router-dom";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  useEffect(() => {
    console.log({ visible })
  }, [visible]);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = () => {
      setVisibility(false);
    };
    return (
      <>
        <CustomNavLinkSmall to={"/"} onClick={scrollTo}>
          <Span>{t("Home")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall to={"/about-us"} onClick={scrollTo}>
          <Span>{t("About us")}</Span>
        </CustomNavLinkSmall>
        {visible && (
          <>
            <CustomNavLinkSmall to={'/terms-and-conditions'} onClick={scrollTo}>
              <Span>{t("Terms & Conditions")}</Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall to={'/privacy-policy'} onClick={scrollTo}>
              <Span>{t("Privacy Policy")}</Span>
            </CustomNavLinkSmall>
          </>
        )}
        <CustomNavAnchorSmall
          href="https://play.google.com/store/apps/details?id=com.render.evcare"
          target="_blank"
          onClick={scrollTo}
        >
          <Span>{t("Download App")}</Span>
        </CustomNavAnchorSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <SvgIcon src="logo.jpeg" width="101px" height="64px" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
